
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact/media",
      function () {
        return require("private-next-pages/contact/media/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact/media"])
      });
    }
  